import { createSelector } from 'reselect';
import { createIntl, createIntlCache } from 'react-intl';
import { CLIENT_TYPES } from '../../../constant.js';

// This is optional but highly recommended
// since it prevents memory leak
const cache = createIntlCache();

const getApp = (state) => state.app;

export const intlSelector = createSelector(
  (state) => state.app.locale,
  (state) => state.app.messages,
  (locale, messages) => createIntl({ locale, messages }, cache)
);

export const selectAlipayClient = createSelector(getApp, (app) => {
  return app.client === CLIENT_TYPES.ALIPAY;
});

export const selectLocale = createSelector(getApp, (app) => app.locale);
